import React from 'react';
import { Building, Users2, Globe, Sparkles } from 'lucide-react';

const VisionFuture = () => {
  const visions = [
    {
      icon: Building,
      title: 'From Rooms to Cities',
      description:
        'Our platform scales from single rooms to entire urban developments, enabling smart city planning and digital urban twins.',
    },
    {
      icon: Users2,
      title: 'Collaborative Spaces',
      description:
        'Multi-user environments where teams across the globe can collaborate in shared immersive spaces in real-time.',
    },
    {
      icon: Globe,
      title: 'Global Accessibility',
      description:
        'Making spatial design and visualization accessible to everyone, democratizing architecture and interior design.',
    },
    {
      icon: Sparkles,
      title: 'AI-First Design',
      description:
        'Future where AI assists every step of the design process, from concept to construction, making better spaces for everyone.',
    },
  ];

  return (
    <section className="relative py-32 px-6 md:px-[7.6923%]">
      {/* Grid background */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            'repeating-linear-gradient(0deg, transparent, transparent 1px, transparent 1px, transparent 7.6923%), repeating-linear-gradient(-90deg, #fff, #fff 1px, transparent 1px, transparent 7.6923%)',
          backgroundSize: '100% 100%',
          opacity: 0.03,
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-20">
          <h2
            className="text-4xl md:text-5xl lg:text-6xl font-semibold mb-6"
            style={{
              color: 'var(--text-primary)',
              letterSpacing: '-0.02em',
            }}
          >
            Vision of the Future
          </h2>
          <p
            className="text-lg md:text-xl max-w-3xl mx-auto"
            style={{ color: 'var(--text-secondary)' }}
          >
            We are redefining how the world experiences space. From individual homes to entire smart cities.
          </p>
        </div>

        {/* Vision grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {visions.map((vision, index) => (
            <div
              key={index}
              className="glass p-8 rounded-3xl border-2 border-orange-200 hover:border-orange-400 transition-all duration-400 hover:shadow-xl"
            >
              <div className="mb-6">
                <vision.icon size={48} color="#FF8000" strokeWidth={1.5} />
              </div>
              <h3
                className="text-2xl font-semibold mb-4"
                style={{ color: 'var(--text-primary)' }}
              >
                {vision.title}
              </h3>
              <p
                className="text-base"
                style={{ color: 'var(--text-secondary)', lineHeight: '1.6' }}
              >
                {vision.description}
              </p>
            </div>
          ))}
        </div>

        {/* Quote section */}
        <div className="glass p-12 md:p-16 rounded-3xl border-l-4 border-[#FF8000] text-center">
          <blockquote>
            <p
              className="text-2xl md:text-3xl lg:text-4xl font-medium mb-6 italic"
              style={{ color: 'var(--text-primary)', lineHeight: '1.4' }}
            >
              "This is not just a website. This is a glimpse into the future of how space itself will be designed, sold, and experienced."
            </p>
          </blockquote>
        </div>
      </div>
    </section>
  );
};

export default VisionFuture;